import {
	Component,
	Input,
	ViewChild
} from '@angular/core';

import { AnalyticsService } from 'rev-shared/analytics/Analytics.Service';
import { GridType } from 'rev-shared/analytics/Constant';
import { mediumDateTimeValueFormatter } from 'rev-shared/ui/dataGrid/valueFormatters/MediumDateTimeValueFormatter';
import { VbConfirmationDialogComponent } from 'rev-shared/ui/dialog/VbConfirmationDialogAngular.Component';

import { EventAnalyticsService } from './EventAnalytics.Service';

import styles from './EventAnalytics.Component.module.less';

enum ViewsColumnPickerGroup {
	EVENT,
	METRICS
}

@Component({
	selector: 'events-grid',
	templateUrl: './EventsGrid.Component.html',
	host: {
		'[class]': 'styles.eventsGridRoot'
	}
})
export class EventsGridComponent {
	@Input() public accountId: string;
	@Input() public header: string;
	@Input() public dataFetchContext: { startDate: string, endDate: string };

	public readonly ViewsColumnPickerGroup = ViewsColumnPickerGroup;
	public readonly mediumDateTimeValueFormatter = mediumDateTimeValueFormatter;
	public readonly GridType = GridType;
	public readonly pageSize = 25;
	public readonly styles = styles;

	@ViewChild(VbConfirmationDialogComponent)
	public downloadConfirmation: VbConfirmationDialogComponent;

	public downloadUrl: string;

	constructor(
		public AnalyticsService: AnalyticsService,
		private EventAnalyticsService: EventAnalyticsService
	){}

	public initiateEventsCsvDownload(): void {
		this.EventAnalyticsService.initiateEventsDownload(this.accountId, this.dataFetchContext)
			.then(() => this.downloadConfirmation.open())
			.catch(ee => console.error('error initiating events downalod', ee));
	}
}
